module.exports = __webpack_public_path__ + "static/media/marker.38210a40.svg";